import React from "react";
import "./DateFilter.css";
import { Button, Grid2 as Grid, TextField } from "@mui/material";
import { isEmpty } from "validate.js";
import moment from "moment";

const DateFilter = ({ formValues, setFormValues, handleSubmit }) => {
  //methods
  const handleChange = (e) => {
    const inputName = e?.target?.name;
    const inputValue = e?.target?.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });
  };

  //builder
  return (
    <div className="p-30">
      <Grid container spacing={2}>
        <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
          <TextField
            fullWidth
            required
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: {
                max: moment().format("YYYY-MM-DD"), // Disallows future dates
              },
            }}
            variant="outlined"
            type="date"
            name="fromDate"
            id="from-date"
            label="From"
            onChange={handleChange}
            value={formValues?.fromDate}
          />
        </Grid>
        <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
          <TextField
            fullWidth
            required
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: {
                max: moment(formValues?.fromDate).format("YYYY-MM-DD"),
              },
            }}
            disabled={isEmpty(formValues?.fromDate)}
            variant="outlined"
            type="date"
            name="toDate"
            id="to-date"
            label="To"
            onChange={handleChange}
            value={formValues?.toDate}
          />
        </Grid>
        <Grid size={{ lg: 2, md: 4, sm: 6, xs: 12 }}>
          <Button
            onClick={handleSubmit}
            id="button-submit"
            disabled={
              isEmpty(formValues?.fromDate) ||
              isEmpty(formValues?.toDate) ||
              moment(formValues?.toDate, "YYYY-MM-DD").diff(
                formValues?.fromDate,
                "YYYY-MM-DD"
              ) < 0
            }
            variant="contained"
            color="primary"
            size="large"
          >
            FILTER
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default DateFilter;
